/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPatientRequestSummary } from './HchbPatientRequestSummary';
import {
    HchbPatientRequestSummaryFromJSON,
    HchbPatientRequestSummaryFromJSONTyped,
    HchbPatientRequestSummaryToJSON,
} from './HchbPatientRequestSummary';

/**
 * 
 * @export
 * @interface HchbPatientRequestList
 */
export interface HchbPatientRequestList {
    /**
     * 
     * @type {Array<HchbPatientRequestSummary>}
     * @memberof HchbPatientRequestList
     */
    data: Array<HchbPatientRequestSummary>;
}

/**
 * Check if a given object implements the HchbPatientRequestList interface.
 */
export function instanceOfHchbPatientRequestList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function HchbPatientRequestListFromJSON(json: any): HchbPatientRequestList {
    return HchbPatientRequestListFromJSONTyped(json, false);
}

export function HchbPatientRequestListFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientRequestList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(HchbPatientRequestSummaryFromJSON)),
    };
}

export function HchbPatientRequestListToJSON(value?: HchbPatientRequestList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(HchbPatientRequestSummaryToJSON)),
    };
}

